import { base, price, regular } from './product.module.scss';

export default function DetailPrice({ product }) {
  return (
    <div className={price}>
      <span
        className={base}
        dangerouslySetInnerHTML={{ __html: product?.price }}
      />
      {product?.onSale && (
        <span
          className={regular}
          dangerouslySetInnerHTML={{ __html: product?.regularPrice }}
        />
      )}
    </div>
  );
}
